import { render, staticRenderFns } from "./VRadioGroup.vue?vue&type=template&id=a1d23cc8"
import script from "./VRadioGroup.vue?vue&type=script&lang=js"
export * from "./VRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./VRadioGroup.vue?vue&type=style&index=0&id=a1d23cc8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1d23cc8')) {
      api.createRecord('a1d23cc8', component.options)
    } else {
      api.reload('a1d23cc8', component.options)
    }
    module.hot.accept("./VRadioGroup.vue?vue&type=template&id=a1d23cc8", function () {
      api.rerender('a1d23cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VRadioGroup.vue"
export default component.exports